/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetApplicationNoticesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetApplicationNoticesQuery = {
  applicationNotices: Array<{
    id: number;
    title: string;
    name: string;
    description: string;
    startTime: any;
    endTime: any;
    active: boolean | null;
    downtime: boolean | null;
    downtimeName: string | null;
    downtimeTitle: string | null;
    downtimeDescription: string | null;
    downtimeStart: any;
    downtimeEnd: any;
  }>;
};

export type GetApplicationNoticeQueryVariables = Exact<{
  applicationNoticeId: number;
}>;

export type GetApplicationNoticeQuery = {
  applicationNotice: {
    id: number;
    title: string;
    name: string;
    description: string;
    startTime: any;
    endTime: any;
    active: boolean | null;
    downtime: boolean | null;
    downtimeName: string | null;
    downtimeTitle: string | null;
    downtimeDescription: string | null;
    downtimeStart: any;
    downtimeEnd: any;
  };
};

export type GetActiveApplicationNoticeQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActiveApplicationNoticeQuery = {
  activeApplicationNotice: {
    id: number;
    title: string;
    name: string;
    description: string;
    startTime: any;
    endTime: any;
    active: boolean | null;
    downtime: boolean | null;
    downtimeName: string | null;
    downtimeTitle: string | null;
    downtimeDescription: string | null;
    downtimeStart: any;
    downtimeEnd: any;
  };
};

export type CreateApplicationNoticeMutationVariables = Exact<{
  input: Types.CreateApplicationNoticeInput;
}>;

export type CreateApplicationNoticeMutation = {
  createApplicationNotice: {
    id: number;
    title: string;
    name: string;
    description: string;
    startTime: any;
    endTime: any;
    active: boolean | null;
    downtime: boolean | null;
    downtimeName: string | null;
    downtimeTitle: string | null;
    downtimeDescription: string | null;
    downtimeStart: any;
    downtimeEnd: any;
  };
};

export type UpdateApplicationNoticeMutationVariables = Exact<{
  input: Types.UpdateApplicationNoticeInput;
}>;

export type UpdateApplicationNoticeMutation = {
  updateApplicationNotice: {
    id: number;
    title: string;
    name: string;
    description: string;
    startTime: any;
    endTime: any;
    active: boolean | null;
    downtime: boolean | null;
    downtimeName: string | null;
    downtimeTitle: string | null;
    downtimeDescription: string | null;
    downtimeStart: any;
    downtimeEnd: any;
  };
};

export type CheckApplicationNoticeConflictQueryVariables = Exact<{
  input: Types.CheckApplicationNoticeConflictInput;
}>;

export type CheckApplicationNoticeConflictQuery = {
  checkApplicationNoticeConflict: {
    title: string;
    startTime: any;
    endTime: any;
  };
};

export type GetUrlMapsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUrlMapsQuery = {
  urlMaps: Array<{
    id: string;
    source: string;
    destination: string;
    priority: number;
    enabled: boolean;
    method: Types.RequestMethod;
    responseType: Types.ResponseType;
  }>;
};

export type GetUrlMapQueryVariables = Exact<{
  urlMapId: string | number;
}>;

export type GetUrlMapQuery = {
  urlMap: {
    id: string;
    source: string;
    destination: string;
    priority: number;
    enabled: boolean;
    method: Types.RequestMethod;
    responseType: Types.ResponseType;
  };
};

export type CreateUrlMapMutationVariables = Exact<{
  input: Types.CreateUrlMapInput;
}>;

export type CreateUrlMapMutation = {
  createUrlMap: {
    id: string;
    source: string;
    destination: string;
    priority: number;
    enabled: boolean;
    method: Types.RequestMethod;
    responseType: Types.ResponseType;
  };
};

export type UpdateUrlMapMutationVariables = Exact<{
  input: Types.UpdateUrlMapInput;
}>;

export type UpdateUrlMapMutation = {
  updateUrlMap: {
    id: string;
    source: string;
    destination: string;
    priority: number;
    enabled: boolean;
    method: Types.RequestMethod;
    responseType: Types.ResponseType;
  };
};

export type RemoveUrlMapMutationVariables = Exact<{
  removeUrlMapId: string | number;
}>;

export type RemoveUrlMapMutation = { removeUrlMap: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: string;
}>;

export type ForgotPasswordMutation = { forgotPassword: boolean };

export type ChangeRequesterPasswordMutationVariables = Exact<{
  newPassword: string;
}>;

export type ChangeRequesterPasswordMutation = {
  changeRequesterPassword: boolean;
};

export type ValidateUserQueryVariables = Exact<{ [key: string]: never }>;

export type ValidateUserQuery = { validateUser: boolean };

export type UserHasSetPasswordQueryVariables = Exact<{
  email: string;
}>;

export type UserHasSetPasswordQuery = { userHasSetPassword: boolean };

export type ForgotUsernameMutationVariables = Exact<{
  email: string;
}>;

export type ForgotUsernameMutation = { forgotUsername: boolean };

export const GetApplicationNoticesDocument = gql`
  query getApplicationNotices {
    applicationNotices {
      id
      title
      name
      description
      startTime
      endTime
      active
      downtime
      downtimeName
      downtimeTitle
      downtimeDescription
      downtimeStart
      downtimeEnd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetApplicationNoticesGQL extends Apollo.Query<
  GetApplicationNoticesQuery,
  GetApplicationNoticesQueryVariables
> {
  document = GetApplicationNoticesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetApplicationNoticeDocument = gql`
  query getApplicationNotice($applicationNoticeId: Float!) {
    applicationNotice(id: $applicationNoticeId) {
      id
      title
      name
      description
      startTime
      endTime
      active
      downtime
      downtimeName
      downtimeTitle
      downtimeDescription
      downtimeStart
      downtimeEnd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetApplicationNoticeGQL extends Apollo.Query<
  GetApplicationNoticeQuery,
  GetApplicationNoticeQueryVariables
> {
  document = GetApplicationNoticeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetActiveApplicationNoticeDocument = gql`
  query getActiveApplicationNotice {
    activeApplicationNotice {
      id
      title
      name
      description
      startTime
      endTime
      active
      downtime
      downtimeName
      downtimeTitle
      downtimeDescription
      downtimeStart
      downtimeEnd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetActiveApplicationNoticeGQL extends Apollo.Query<
  GetActiveApplicationNoticeQuery,
  GetActiveApplicationNoticeQueryVariables
> {
  document = GetActiveApplicationNoticeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateApplicationNoticeDocument = gql`
  mutation createApplicationNotice($input: CreateApplicationNoticeInput!) {
    createApplicationNotice(input: $input) {
      id
      title
      name
      description
      startTime
      endTime
      active
      downtime
      downtimeName
      downtimeTitle
      downtimeDescription
      downtimeStart
      downtimeEnd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateApplicationNoticeGQL extends Apollo.Mutation<
  CreateApplicationNoticeMutation,
  CreateApplicationNoticeMutationVariables
> {
  document = CreateApplicationNoticeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateApplicationNoticeDocument = gql`
  mutation updateApplicationNotice($input: UpdateApplicationNoticeInput!) {
    updateApplicationNotice(input: $input) {
      id
      title
      name
      description
      startTime
      endTime
      active
      downtime
      downtimeName
      downtimeTitle
      downtimeDescription
      downtimeStart
      downtimeEnd
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateApplicationNoticeGQL extends Apollo.Mutation<
  UpdateApplicationNoticeMutation,
  UpdateApplicationNoticeMutationVariables
> {
  document = UpdateApplicationNoticeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckApplicationNoticeConflictDocument = gql`
  query checkApplicationNoticeConflict(
    $input: CheckApplicationNoticeConflictInput!
  ) {
    checkApplicationNoticeConflict(input: $input) {
      title
      startTime
      endTime
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckApplicationNoticeConflictGQL extends Apollo.Query<
  CheckApplicationNoticeConflictQuery,
  CheckApplicationNoticeConflictQueryVariables
> {
  document = CheckApplicationNoticeConflictDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUrlMapsDocument = gql`
  query getUrlMaps {
    urlMaps {
      id
      source
      destination
      priority
      enabled
      method
      responseType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUrlMapsGQL extends Apollo.Query<
  GetUrlMapsQuery,
  GetUrlMapsQueryVariables
> {
  document = GetUrlMapsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUrlMapDocument = gql`
  query getUrlMap($urlMapId: ID!) {
    urlMap(id: $urlMapId) {
      id
      source
      destination
      priority
      enabled
      method
      responseType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUrlMapGQL extends Apollo.Query<
  GetUrlMapQuery,
  GetUrlMapQueryVariables
> {
  document = GetUrlMapDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateUrlMapDocument = gql`
  mutation createUrlMap($input: CreateUrlMapInput!) {
    createUrlMap(input: $input) {
      id
      source
      destination
      priority
      enabled
      method
      responseType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateUrlMapGQL extends Apollo.Mutation<
  CreateUrlMapMutation,
  CreateUrlMapMutationVariables
> {
  document = CreateUrlMapDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUrlMapDocument = gql`
  mutation updateUrlMap($input: UpdateUrlMapInput!) {
    updateUrlMap(input: $input) {
      id
      source
      destination
      priority
      enabled
      method
      responseType
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUrlMapGQL extends Apollo.Mutation<
  UpdateUrlMapMutation,
  UpdateUrlMapMutationVariables
> {
  document = UpdateUrlMapDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RemoveUrlMapDocument = gql`
  mutation removeUrlMap($removeUrlMapId: ID!) {
    removeUrlMap(id: $removeUrlMapId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RemoveUrlMapGQL extends Apollo.Mutation<
  RemoveUrlMapMutation,
  RemoveUrlMapMutationVariables
> {
  document = RemoveUrlMapDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ForgotPasswordDocument = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordGQL extends Apollo.Mutation<
  ForgotPasswordMutation,
  ForgotPasswordMutationVariables
> {
  document = ForgotPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ChangeRequesterPasswordDocument = gql`
  mutation changeRequesterPassword($newPassword: String!) {
    changeRequesterPassword(newPassword: $newPassword)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChangeRequesterPasswordGQL extends Apollo.Mutation<
  ChangeRequesterPasswordMutation,
  ChangeRequesterPasswordMutationVariables
> {
  document = ChangeRequesterPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ValidateUserDocument = gql`
  query validateUser {
    validateUser
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ValidateUserGQL extends Apollo.Query<
  ValidateUserQuery,
  ValidateUserQueryVariables
> {
  document = ValidateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserHasSetPasswordDocument = gql`
  query userHasSetPassword($email: String!) {
    userHasSetPassword(email: $email)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UserHasSetPasswordGQL extends Apollo.Query<
  UserHasSetPasswordQuery,
  UserHasSetPasswordQueryVariables
> {
  document = UserHasSetPasswordDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ForgotUsernameDocument = gql`
  mutation forgotUsername($email: String!) {
    forgotUsername(email: $email)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ForgotUsernameGQL extends Apollo.Mutation<
  ForgotUsernameMutation,
  ForgotUsernameMutationVariables
> {
  document = ForgotUsernameDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
